export default __webpack_public_path__ + "static/media/ITOAM-booked-dark.e4c09b17.svg";